<template>
  <div>
    <CRow>
      <template v-if="!loadingTab">
        <CCol sm="12"><br /></CCol>
        <CCol sm="12" v-if="orders">
          <GlobalTable
            :title="'List Order'"
            :fields="fields"
            :items="items"
            :editButton="false"
            :redirectDetail="false"
            :removeButton="true"
            :isLoading="isLoading"
            :withCard="false"
            @addForm="addForm"
            @removeData="removeData"
          ></GlobalTable>
        </CCol>
      </template>

      <template v-else>
        <CCol sm="12"><loading></loading></CCol>
      </template>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form Detail Order</h6>
      </template>

      <CForm>
        <CRow>
          <CCol lg="3">
            <div class="form-group">
              <label for="product_code">Product</label>
              <model-select
                class="form-control"
                id="product_code"
                :options="productList"
                v-model="$v.orderDetailForm.product_code.$model"
                :isError="$v.orderDetailForm.product_code.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.orderDetailForm.product_code.$invalid"
                class="invalid-feedback-custom"
              >
                Product should be filled.
              </div>
            </div>
          </CCol>

          <CCol lg="3">
            <CInput
              label="Qty"
              invalid-feedback="Order number should be filled"
              required
              v-model="$v.orderDetailForm.qty.$model"
              :is-valid="!$v.orderDetailForm.qty.$invalid"
            />
          </CCol>
        </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.orderDetailForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import Loading from "../../../templates/Loading";
import GlobalTable from "../../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

export default {
  name: "OrderList",
  components: { GlobalTable, Loading },
  data() {
    return {
      addButton: false,
      isEdit: false,
      image: null,
      title: "Order Detail",
      activeTab: 0,
      loadingTab: false,
      checkedFlag: "Agent",
      fields: [
        { key: "product_code", label: "Code Product" },
        { key: "product_name", label: "Product" },
        { key: "qty", label: "Quantity" },
        { key: "price", label: "Price" },
        { key: "total", label: "Total" },
        { key: "action", _classes: "text-center action" },
      ],
      orderDetailForm: tableInterfaces.order_detail,
      productList: [],
      itemsNewListing: [],
    };
  },
  props: {
    items: {
      type: [Array, Object],
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    orders: {
      type: [Array, Object],
      default: () => [],
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  validations: {
    orderDetailForm: {
      order_number: {},
      product_code: { required },
      qty: { required },
      price: {},
    },
  },
  methods: {
    init: function () {
      this.getDropdown();
    },
    refreshOrderListing: function (id) {
      this.loadingTab = true;
      this.axios.get("/console/order/listing_order_detail/" + id).then((response) => {
        this.$emit("update:items", response.data.data);
        //this.items = response.data.data;
        this.loadingTab = false;
      });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    removeData: function (item) {
      if (confirm("Do you want to remove this data ?")) {
        this.axios.delete("/console/order/order-detail/" + item.id).then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
              let path = this.$route.path.split("/");
              this.refreshOrderListing(path[4]);
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.cancelForm();
          });
      }
    },
    resetForm: function () {
      for (var i in tableInterfaces.order_detail) {
        tableInterfaces.order_detail[i] = null;
      }
      this.orderDetailForm = tableInterfaces.order_detail;
    },
    getDropdown: function () {
      this.axios
        .get("/console/dropdown/product/by-agent/" + this.orders.agent_code)
        .then((response) => {
          this.productList = response.data.data;
        });
    },
    submitForm: function (event) {
      event.preventDefault();
      if (confirm("Do you want to add this data ?")) {
        this.orderDetailForm.order_number = this.orders.order_number;
        this.orderDetailForm.user_code = this.orders.user_code;
        this.axios
          .post("console/order/add-detail", this.orderDetailForm)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
              let path = this.$route.path.split("/");
              this.refreshOrderListing(path[4]);
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.cancelForm();
          });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
